import { render, staticRenderFns } from "./AddAttachment.vue?vue&type=template&id=4bcaa872"
import script from "./AddAttachment.vue?vue&type=script&lang=js"
export * from "./AddAttachment.vue?vue&type=script&lang=js"
import style0 from "./AddAttachment.vue?vue&type=style&index=0&id=4bcaa872&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports